import BaseAPI from "@/api/BaseAPI";

export class CoStagesAPI extends BaseAPI {
  constructor() {
    super('/stageData');
  }

  /**
   * @param {1 | 2 | 3} foId
   * @param {Number} founderId
   * @param {Number} kcpGroupId
   * */
  getDataStage(kcpGroupId, foId = 1, founderId) {
    return this.http.get(`/dataCo`, {data: {founderId, kcpGroupId, foId}})
  }

  /**
   * @param {{
   *       id: number | 0,
   *       stageDataId: number,
   *       value: number,
   *       textVal: string,
   *       founder: {id: number},
   *       stageId: number
   * }} data
   * */
  saveDataOffer(data) {
    return this.http.post(`/${data.id ? 'update' : 'add'}Offers`, {data})
  }

  /**
   * @param {Number} founderId
   * @param {Number} kcpGroupId
   * */
  getDataStageThreeSumsForKcp(kcpGroupId, founderId) {
    return this.http.get(`/stageDataSumZayavka/get`, {data: {founderId, kcpGroupId}})
  }


  /**
   * @param {Number} stageDataId
   * */
  getDataById(stageDataId) {
    return this.http.get(`/getById?stageDataId=${stageDataId}`)
  }
}

export default new CoStagesAPI()